import { useContext } from 'react';
import { AuthContext } from "../../../Contexts/auth";

function GetUserId() {
    const { user } = useContext(AuthContext);
    const userId = user ? user.id : null;
    return userId
};

export default GetUserId;
